import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import {
  Avatar,
  Box,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import { AuthContext } from "../../../store";

export const ProfileCard = (props) => {
  const { collapse } = props;
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { auth } = useContext(AuthContext);
  const isStoreAdmin = pathname.includes("store-admin");
  const isSuperAdminPermission = auth?.data?.roles?.find(
    (item) => item.name === "admin"
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClickMenu = (event, index) => {
    !anchorEl && setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const isStoreAdminPermission =
    auth?.data?.roles?.find((item) => item.name === "store-admin") &&
    auth.data.stores.length;

  const navigateSwitchDependingOnUser = () => {
    isStoreAdmin ? navigate("/") : navigate("/store-admin/");
  };

  const handleLogout = async () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.pathname = "/authentication/login";
  };

  return (
    <Box
      sx={{
        m: collapse ? "0px 12px 16px" : "0px 10.5px 16px",
      }}
    >
      <Box
        sx={{
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <Stack
          sx={{
            flexDirection: "row",
            alignItems: "center",
            gap: "8px",
            backgroundColor: collapse ? "#FFFCEB" : "",
            transition: "background-color .7s ease",
            p: "4px 8px 4px 6px",
            textAlign: "left",
          }}
        >
          <Avatar alt="user" sx={{ height: "32px", width: "32px" }} />
          {collapse ? (
            <>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 500,
                  color: "#000",
                  width: "100%",
                  whiteSpace: "nowrap",
                }}
              >
                {auth?.data?.first_name + " " + auth?.data?.last_name}
              </Typography>

              <img
                src="/icons/ic_more_horizontal.svg"
                alt="menu"
                style={{
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  handleClickMenu(e);
                }}
              />
            </>
          ) : (
            ""
          )}
        </Stack>

        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={collapse && openMenu}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          slotProps={{
            paper: {
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.20))",
                mt: 3.5,
                ml: 2.5,
                width: "250px",
                borderRadius: "15px",
              },
            },
          }}
        >
          <Stack
            sx={{
              flexDirection: "row",
              padding: "12px 8px",
              gap: "8px",
            }}
          >
            <Avatar
              alt="user"
              sx={{
                height: "40px",
                width: "40px",
                backgroundColor: "#EEE4D5",
                color: "#564845",
              }}
            >
              {auth?.data?.first_name?.[0] ?? ""}
            </Avatar>
            <Stack gap="2px">
              <Typography
                variant="subtitle1"
                fontWeight={500}
                height={19}
                lineHeight={1.2}
                textOverflow="ellipsis"
                overflow="hidden"
                whiteSpace="nowrap"
                width="180px"
              >
                {auth?.data?.first_name + " " + auth?.data?.last_name}
              </Typography>
              <Typography
                variant="caption"
                color="#636A75"
                lineHeight="15px"
                textOverflow="ellipsis"
                overflow="hidden"
                whiteSpace="nowrap"
                width="180px"
              >
                {auth?.data.email}
              </Typography>
              <Typography
                variant="caption"
                color="#636A75"
                lineHeight="15px"
                textOverflow="ellipsis"
                overflow="hidden"
                whiteSpace="nowrap"
                width="180px"
              >
                +{auth?.data.country_code} {auth.data.phone}
              </Typography>
            </Stack>
          </Stack>
          <Divider />

          {(!isStoreAdmin && isStoreAdminPermission) ||
          (isStoreAdmin && isSuperAdminPermission) ? (
            <MenuItem
              onClick={navigateSwitchDependingOnUser}
              sx={{
                gap: "8px",
                alignItems: "center",
                pl: "6px",
                height: "40px",
              }}
            >
              <ListItemIcon>
                <img alt="SA" src="/icons/Repeat.svg" />
              </ListItemIcon>
              <ListItemText
                primary={`Switch to ${
                  isStoreAdmin ? "Super Admin" : "Store Admin"
                }`}
                primaryTypographyProps={{
                  sx: {
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "#10151A",
                  },
                }}
              />
            </MenuItem>
          ) : (
            ""
          )}
          <Divider
            sx={{
              m: "0 !important",
            }}
          />
          <ListItemButton
            onClick={handleLogout}
            sx={{
              justifyContent: "center",
              height: "40px",
              fontWeight: 600,
            }}
          >
            Logout
          </ListItemButton>
        </Menu>
      </Box>
    </Box>
  );
};
